import { Component, Input, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { DTypeFormField, DTypeFormFreeTextField } from '@grupo-constant/next-dtype/form';
import { DTypeFormFieldComponent } from '../dtype-field.model';
import { DtypeFieldsRegistry } from '../dtype-fields.registry';
import { DtypeDirective } from '../dtype.directive';

@Component({
    selector: 'dtype-item',
    template: '<ng-template dtypeItemHost></ng-template>',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DtypeItemComponent implements OnInit, DTypeFormFieldComponent {

    @Input() field: DTypeFormField | DTypeFormFreeTextField;
    @Input() isUpdate: boolean;
    @Input() useSummaryView: boolean;

    @ViewChild(DtypeDirective, { static: true }) formHost: DtypeDirective;

    component: DTypeFormFieldComponent;

    constructor() { }

    ngOnInit(): void {
        const viewContainerRef = this.formHost.viewContainerRef;
        const fieldType = DtypeFieldsRegistry.getFieldType(this.field.dTypeCol);
        const component = DtypeFieldsRegistry.getFieldComponent(fieldType);
        if (component) {
            const componentRef = viewContainerRef.createComponent(component);
            this.component = (componentRef.instance as DTypeFormFieldComponent);
            this.component.field = this.field;
            this.component.isUpdate = this.isUpdate === true;
            this.component.useSummaryView = this.useSummaryView === true;
        }
    }
}
